export default __webpack_public_path__ + "static/media/document.cd430a1c.gif";